import {HumanObjectTransform} from '../../edit/models/scene-graph-node';
/* Synchronization is the process by which the state of any and every object of
the graph with a single traversal.

Synchronization is the most expensive step in chapter activation. We can
minimize the cost by enforcing full state setting in a single graph traversal.

Synchronization should also unambiguously set the state given partial record of
state. It does this through inheritable properties. With inheritable properties,
a node in the graph's property is inherited from its parent unless an explicit
override is listed in the synchronization object - that overwritten state is
then inheritable record as synchronization proceeds down the tree.

Not all properties are inheritable, however. Transforms, for example, are meant
to match exactly to the node in the graph on which it is defined in the
synchronization object.

INHERITABLE attributes 1 - shown 2 - pickable 3 - selected 4 - opacity 5 -
colorRecipes[id] 6 - colorMods

UNINHERITABLE attributes 1 - transform

A note on colorMods. Why is each channel of type 'boolean | number'? There is no
number value equivalent to 'no modification'. Therefore, in order to support
inheritance through synchronization, a channel set to false will terminate the
modfiication.
*/

export class SynchronizationModel {
    [key: string]: {
        shown?: boolean,
        pickable?: boolean,
        selected?: boolean,
        opacity?: number,
        transform?: HumanObjectTransform,
        xray?: boolean,
        colorRecipes?: {
            [key: string]: {
                [key: string]: boolean
            }
        },
        colorMods?: {
            tintColor?: boolean | number[],
            saturation?: boolean | number,
            contrast?: boolean | number,
            brightness?: boolean | number,
            opacity?: boolean | number
        }
    }
}
